;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function Clipboard() {
  return (
    <svg width="143" height="134" viewBox="0 0 143 134" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M62.4253 132V115.786C62.4253 108.519 53.1478 104.788 47.3219 104.788C41.4959 104.788 32.2184 108.519 32.2184 115.786V132"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.3217 104.788C52.6033 104.788 56.3907 101.334 56.3907 96.3272V92.0971C56.3907 87.0905 52.6033 83.6367 47.3217 83.6367C42.0402 83.6367 38.2527 87.0905 38.2527 92.0971V96.3272C38.2527 101.334 42.0402 104.788 47.3217 104.788Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M101.713 132V124.849C101.713 117.583 92.4352 113.851 86.6092 113.851C80.7833 113.851 71.5057 117.583 71.5057 124.849V132"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.5976 113.862C91.8792 113.862 95.6667 110.409 95.6667 105.402V101.172C95.6667 96.1649 91.8792 92.7112 86.5976 92.7112C81.316 92.7112 77.5286 96.1649 77.5286 101.172V105.402C77.5286 110.409 81.316 113.862 86.5976 113.862Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M140.989 132V130.899C140.989 123.632 131.712 119.901 125.886 119.901C120.06 119.901 110.782 123.632 110.782 130.899V132"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.886 119.912C131.167 119.912 134.955 116.458 134.955 111.452V107.222C134.955 102.215 131.167 98.7612 125.886 98.7612C120.604 98.7612 116.817 102.215 116.817 107.222V111.452C116.817 116.458 120.604 119.912 125.886 119.912Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M32.2185 86.6498H26.1725V98.3785C26.1725 101.322 22.3966 102.528 20.694 100.14L11.069 86.6498H8.04598C4.71025 86.6498 2 83.9379 2 80.6001V41.2884C2 37.9506 4.69866 35.2502 8.03439 35.2502H68.483C71.8187 35.2502 74.5175 37.9506 74.5175 41.2884V80.6001C74.5175 83.9379 71.8071 86.6498 68.4714 86.6498H65.4484"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M80.5639 56.4245H89.6329V68.1531C89.6329 71.0968 93.4088 72.3022 95.1114 69.9147L104.736 56.4245H113.805C117.141 56.4245 119.851 53.7125 119.851 50.3748V8.03811C119.851 4.70032 117.153 2 113.817 2H35.2419C31.9062 2 29.2075 4.70032 29.2075 8.03811V29.2122"
        stroke="#E2001A"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M101.713 74.5621H110.782V86.2907C110.782 89.2345 114.557 90.4398 116.26 88.0524L125.885 74.5621H134.954C138.29 74.5621 141 71.85 141 68.5123V29.2006C141 25.8628 138.301 23.1624 134.966 23.1624H125.897"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
